import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { AppointmentType, AppointmentTypeWrite, ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useUpdateAppointmentType(): UseMutationResult<
  AxiosResponse<AppointmentType>,
  AxiosError<ErrorMessage>,
  AppointmentTypeWrite
> {
  const queryClient = useQueryClient();

  const updateAppointmentType = (
    appointmentType: AppointmentTypeWrite,
  ): Promise<AxiosResponse<AppointmentType>> => {
    return client.put(`appointment-types/${appointmentType?.appointmentTypeId}/`, appointmentType);
  };

  return useMutation(updateAppointmentType, {
    onSuccess: () => {
      queryClient.invalidateQueries(['appointmentType']);
      queryClient.invalidateQueries({
        queryKey: ['appointmentPayRateLookups'],
      });
    },
  });
}
